import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'equipment_costs'

export const dataPointDefinition = {
  retracedId: 'equipment_costs',
  name: 'Equipment costs',
  description:
    'Refers to costs for tools, uniforms, safety gear, and other equipment needed to perform assigned work safely and effectively.',
  meta: {
    slcpMeta: {
      key: 'rh-rec-2x',
      number: 'RH-REC-5-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'rh-rec-1',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fl-4,Worker Only;Facility and Worker',
      machineShowHide: '[2],fl-4,2;3',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-rec-2x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34570,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
